import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import {
  AveragePlayerScore,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { PlayerScore } from '@sorare/core/src/components/scoring/PlayerScore';
import type { TotalAveragePlayerScore } from '@sorare/core/src/lib/averagePlayerScore';

import { InlineCard } from '@sorare/marketplace/src/components/card/InlineCard';

import type { RecentPurchase_anyCardInterface } from './__generated__/index.graphql';

const Root = styled(SBHorizontal)`
  position: relative;
`;

export enum TradeType {
  BUY,
  SELL,
}

const modeBySport: Record<Sport, TotalAveragePlayerScore> = {
  [Sport.FOOTBALL]: AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE,
  [Sport.NBA]: AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE,
  [Sport.BASEBALL]: AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE,
};

type Props = { anyCard: RecentPurchase_anyCardInterface };
export const RecentPurchase = ({ anyCard }: Props) => {
  return (
    <Root>
      <InlineCard anyCard={anyCard} withPositions />
      <PlayerScore
        small
        player={anyCard.anyPlayer}
        mode={modeBySport[anyCard.sport]}
      />
    </Root>
  );
};

RecentPurchase.fragments = {
  anyCardInterface: gql`
    fragment RecentPurchase_anyCardInterface on AnyCardInterface {
      slug
      name
      sport
      anyPlayer {
        slug
        ...PlayerScore_anyPlayer
      }
      ...InlineCard_anyCardInterface
    }
    ${PlayerScore.fragments.anyPlayer}
    ${InlineCard.fragments.anyCard}
  ` as TypedDocumentNode<RecentPurchase_anyCardInterface>,
};
